import { gql } from '@apollo/client';

export const ALL_MODULES = gql`
  query AllModules {
    modules: getModules {
      id
      name
      editable
    }
  }
`;
